export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_DEFAULT_complete_5.7d5120d9.jpg";